module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "aubio"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _c('b', [_vm._v("Sharon R. Krause")]), _vm._v(" is professor in and chair of the Department of Political Science at Brown University. She is the author of "), _c('i', [_vm._v("Civil Passions")]), _vm._v(" and "), _c('i', [_vm._v("Liberalism with Honor")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2015 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. Published 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("24 23 22 21 20 19 18 17 16 15   1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-23469-4 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-23472-4 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: 10.7208/chicago/9780226234724.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Krause, Sharon R., author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v(" Freedom beyond sovereignty : reconstructing liberal individualism / Sharon R. Krause.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v(" Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v(" ISBN 978-0-226-23469-4 (cloth : alkaline paper) — ISBN 978-0-226-23472-4 (e-book) 1. Individualism—United States. 2. Liberalism—United States. 3. Agent (Philosophy) I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v(" JC574.2.U6K74 2015")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v(" 320.510973—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("\t2014025468")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f55d256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-krause-0004.vue
// module id = 63
// module chunks = 0